module.exports = __webpack_public_path__ + "_/_/src/components/toolbar/image/reception2-icon-sleek-1.png";